<template>
  <v-dialog
    v-model="isShowPreferenceDialog"
    width="400px"
    :before-close="close"
    :modal-append-to-body="false"
    @click:outside="close"
    persistent
    style="z-index: 210"
  >
    <v-row no-gutters style="background-color: #21343b; justify-content: space-between" class="px-3 py-5">
      <span class="txt-title ml-2">{{ dialogTitle }}</span>
      <v-btn dark elevation="0" icon @click="close">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-row>
    <v-row class="ma-0 px-2 pb-4" justify="start" style="background-color: #21343b; font-size: 15px">
      <v-col align-self="center">
        <span class="mr-1" style="color: #96a7af">{{ dialogContent }}</span>
        <b>
          <u>
            <a :href="linkUrl" style="color: white">{{ $t('preferenceDialogContentLink') }}</a>
          </u>
        </b>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      isShowPreferenceDialog: false,
      linkUrl: '',
    }
  },
  methods: {
    close() {
      this.$store.dispatch('setShowPreferenceDialog', null)
      this.isShowPreferenceDialog = false
    },
  },
  computed: {
    showPreferenceDialog() {
      return this.$store.getters.showPreferenceDialog
    },
    dialogTitle() {
      return `${this.$t('preferenceDialogTitle')} ${this.showPreferenceDialog}`
    },
    dialogContent() {
      return `${this.$t('preferenceDialogContent1')} ${this.showPreferenceDialog}-recording ${this.$t(
        'preferenceDialogContent2'
      )}`
    },
  },
  watch: {
    showPreferenceDialog(val) {
      if (val && val !== null) {
        this.isShowPreferenceDialog = true
        let path = 'x-apple.systempreferences:com.apple.preference.security?'
        switch (val) {
          case 'audio':
            path += 'Privacy_Microphone'
            break
          case 'camera':
            path += 'Privacy_Camera'
            break
          case 'screen':
            path += 'Privacy_ScreenCapture'
            break
          default:
            break
        }
        this.linkUrl = path
      } else {
        this.isShowPreferenceDialog = false
      }
    },
  },
}
</script>

<style>
.txt-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
</style>
